import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { EnumDescriptor } from '../../enum-descriptor';
import { PeriodState } from 'src/app/proxy/periods';

@Component({
  selector: 'app-period-state-dropdown',
  templateUrl: './period-state-dropdown.component.html',
  standalone: false,
})
export class PeriodStateDropdownComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() periodState: PeriodState;

  @Output() changePeriodState = new EventEmitter<PeriodState>();

  periodStates: EnumDescriptor[];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.isNullOrUndefined(this.periodState)) {
      this.periodState = PeriodState.Active;
    }

    this.loadPeriodStates();
    this.onSelected();
  }

  loadPeriodStates(): void {
    this.periodStates = this.getEnumOptions(PeriodState, false);
  }

  onSelected(): void {
    this.changePeriodState.emit(this.periodState);
  }

    setSelectedState(state: PeriodState | undefined): void {
    this.periodState = state;
    this.onSelected();
  }
}
